export default `
  query getPayerUserSubscription {
    getPayerUserSubscription {
      email
      payerUserId
      createdAt
      updatedAt
    }
  }
`
